import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: '80vh'
    },
    firstSceneContainer: {
        display: 'flex',
        flexDirection: "column",
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    },
    scenesColumn: {
        display: 'flex',
        flexDirection: "column",
        justifyContent: 'end',
        paddingLeft: 50
    },
    firstSceneButton: {
        maxWidth: 350
    },
    numberOfScenes: {
        color: theme.palette.text.secondary,
        fontWeight: "bold",
        fontSize: 20
    }
}));

export {useStyles};